import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Calendar } from 'primereact/calendar';
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';



export const CellActivity = ({products,setProducts,setMontantTotal,exercice, isEnfant,selectedEnfant,setIncompleteSelectedEnfant,setIncompleteActivity}) => {



    const columns = [
        { field: 'name', header: 'Name' },
        { field: 'price', header: 'Price' },
        { field: 'dateFacture', header: 'dateFacture' },
    ];
    const fr = {
        		   "firstDayOfWeek": 1,
        		   "dayNames": ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
                   "dayNamesShort": ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
                   "dayNamesMin": ["Di", "Lu", "Mar", "Mer", "Je", "Ve", "Sa"],
                   "monthNames": ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
                   "monthNamesShort": ["Jan", "Fev", "Mar", "Avr", "Mai", "Jun", "Jui", "Août", "Sept", "Oct", "Nov", "Dec"]
    };

    addLocale('fr', fr);

    locale('fr');

    let emptyProduct = {
                name: '',
                price: null,
                dateFacture:null
    };

    let maxDate= new Date(exercice,11,31);



    let minDate = new Date(exercice,0,1);


    const openNew = (e) => {
        products.forEach( product => {
           if(product.name.length > 0 && product.price > 0 && product.dateFacture != null){
                        setIncompleteActivity(false);
           }else{
                        setIncompleteActivity(true);
           }
        });
        if(isEnfant && !selectedEnfant){
            setIncompleteSelectedEnfant(true);
            e.preventDefault();
        } else{
            setIncompleteSelectedEnfant(false);
            let _products = [...products];
             _products.push(emptyProduct);
             setProducts(_products);
             e.preventDefault();
        }

    };


    const deleteActivity = (rowData,e) => {
                let _products = products.filter((val) => val.name !== rowData['name']);
                setProducts(_products);
                updateMontantTotal(_products);
                e.preventDefault();
    };

    const updateMontantTotal= (products) =>{
        let sum = 0;
        products.forEach( product => {
            if(product.name.length > 0 && product.price > 0 && product.dateFacture != null){
                sum += product.price;
                setIncompleteActivity(false);
            }
        });
        setMontantTotal(parseFloat(sum.toFixed(2)));
        return;
    };

    const dateTemplate = (date) => {
                    if(date.selectable){
                        return (
                                <strong>{date.day}</strong>
                                );
                    }
                    else {
                        return (
                                <strong style={{ opacity: 0.3}}>{date.day}</strong>
                                );
                    }
        }


    const isPositiveInteger = (s) => {
        return !isNaN(s) && Number(s) > 0;;
    };

    const onCellEditComplete = (e) => {
        if(isEnfant && !selectedEnfant){
                    setIncompleteSelectedEnfant(true);

        } else{
            setIncompleteSelectedEnfant(false);
            let { rowData, newValue, field, originalEvent: event } = e;
            switch (field) {
                case 'price':
                    if (isPositiveInteger(newValue)){ rowData[field] = newValue;}
                    else event.preventDefault();
                    break;
                case 'dateFacture':
                    rowData[field] = newValue;event.preventDefault();
                    break;
                default:
                    if (newValue.trim().length > 0) rowData[field] = newValue;
                    else event.preventDefault();
                    break;
            }
            updateMontantTotal(products);
        }
    };

    const cellEditor = (options) => {
        if (options.field === 'price') return priceEditor(options);
        if (options.field === 'dateFacture') return dateFactureEditor(options);
        else return textEditor(options);
    };

    const textEditor = (options) => {

        return <div ><label htmlFor="name" class="no-margein-left">Nom de l'activité</label>
                                        <InputText  keyfilter={/^[^!#$%&'*+/=?^{|}~"(),:;<>[\]\\@\d<>*!«»“”]+$/}  maxLength="30" type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} /></div>;
    };

    const priceEditor = (options) => {
              return   <div >
                 <label htmlFor="price" class="no-margein-left">Montant (de l'inscription annuelle, trimestrielle, carnet de tickets)</label>
             <InputNumber  value={options.value} onValueChange={(e) => options.editorCallback(e.value)}  maxFractionDigits={2} /></div>;
   };

    const dateFactureEditor = (options) => {
                  return   <div >
                     <label htmlFor="dateFacture" class="no-margein-left">Date de la facture, du reçu ou de l'attestation de paiement</label>
                 <Calendar locale="fr" dateTemplate={dateTemplate} dateFormat="dd/mm/yy" minDate={minDate} maxDate={maxDate} value={options.value} onChange={(e) => options.editorCallback(e.value)} showIcon/>
                 </div>;
    };

    const priceBodyTemplate = (rowData) => {
        return <div >
                               <label htmlFor="price" class="no-margein-left">Montant (de l'inscription annuelle, trimestrielle, carnet de tickets)</label>
                               <InputNumber  inputId="montant" value={rowData['price']}  placeholder="Montant en euros" currency="EUR" locale="fr-FR" mode="currency" maxFractionDigits={2}  />
                           </div>;
    };

    const nameBodyTemplate = (rowData) => {
            return <div >
                       <label htmlFor="name" class="no-margein-left">Nom de l'activité</label>
                       <InputText id="name" keyfilter={/^[^!#$%&'*+/=?^{|}~"(),:;<>[\]@\d<>*!]+$/}  maxLength="30" value={rowData['name']} aria-describedby="username-help" />
                   </div>;
    };

    const dateFactureBodyTemplate = (rowData) => {
                return <div >
                           <label htmlFor="name" class="no-margein-left">Date de la facture, du reçu ou de l'attestation de paiement</label>
                           <Calendar locale="fr" dateTemplate={dateTemplate} dateFormat="dd/mm/yy" minDate={minDate} maxDate={maxDate} value={rowData['dateFacture']} showIcon/>
                       </div>;
    };

    const DeleteBodyTemplate = (rowData) => {
                return <div style={{marginTop: '20%'}} >
                                           <Button label="Supprimer"  class="disabled" onClick={e=>deleteActivity(rowData,e)} />
                       </div>;
    };




    return (
        <div className="card">
            <DataTable value={products} editMode="cell" >
                {columns.map(({ field, header }) => {

                         return <Column key={field} field={field}  body={ (field === 'name' && nameBodyTemplate) || (field === 'price' && priceBodyTemplate) || (field === 'dateFacture' && dateFactureBodyTemplate)} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />;

                })}
                <Column body={DeleteBodyTemplate} ></Column>
            </DataTable>
            <div style={{marginLeft: '1%'}}>
                <Button label="Ajouter une activité" icon="pi pi-plus" onClick={e => openNew(e)} />
            </div>

        </div>
    );
}
